var phone_number = {};
module['exports'] = phone_number;
phone_number.formats = require("./formats");



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/de_CH/phone_number/index.js
 ** module id = 392
 ** module chunks = 0
 **/